import { PhoneCall } from "@phosphor-icons/react";
import { contactInfo, media } from "@/data/siteContent";

const navItems = [
  { label: "Hizmetler", href: "#hizmetler" },
  { label: "Hakkımızda", href: "#hakkimizda" },
  { label: "Galeri", href: "#galeri" },
  { label: "Konum", href: "#konum" },
  { label: "Güvence", href: "#guvence" },
  { label: "İletişim", href: "#iletisim" },
];

const toTestSlug = (value) => value
  .toLocaleLowerCase("tr-TR")
  .replaceAll("ı", "i")
  .replaceAll("ğ", "g")
  .replaceAll("ü", "u")
  .replaceAll("ş", "s")
  .replaceAll("ö", "o")
  .replaceAll("ç", "c")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/[^a-z0-9]+/g, "-")
  .replace(/(^-|-$)/g, "");

export default function Header() {
  return (
    <header data-testid="site-header" className="fixed left-0 right-0 top-0 z-50 border-b border-white/10 bg-black/80">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 lg:px-8">
        <a data-testid="header-logo-link" href="#anasayfa" className="group flex items-center" aria-label="Has Kırıkhan Nakliyat ana sayfa">
          <img
            data-testid="header-logo-image"
            src={media.logo}
            alt="Has Kırıkhan logosu"
            className="h-10 w-auto max-w-[220px] object-contain transition-transform duration-300 group-hover:scale-105 sm:h-12 sm:max-w-[260px]"
          />
        </a>

        <nav data-testid="desktop-navigation" className="hidden items-center gap-8 md:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              data-testid={`nav-link-${toTestSlug(item.label)}`}
              href={item.href}
              className="text-sm font-bold text-slate-300 transition-colors duration-300 hover:text-orange-400"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          data-testid="header-call-button"
          href={contactInfo.phoneHref}
          className="inline-flex items-center justify-center gap-2 rounded-full border border-[#25D366]/50 bg-[#25D366] px-4 py-3 text-sm font-black text-white transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[#1DA851] hover:shadow-[0_8px_30px_rgba(37,211,102,0.35)]"
        >
          <PhoneCall size={18} weight="bold" />
          <span data-testid="header-call-text" className="hidden lg:inline">{contactInfo.phoneDisplay}</span>
          <span data-testid="header-call-short-text" className="hidden sm:inline lg:hidden">Hemen Ara</span>
        </a>
      </div>
    </header>
  );
}